import React from 'react';
import { useIntl } from 'react-intl';
import css from './CustomAboutUsPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import backgroundImage from './images/bgr1.jpg';
import davidPic from './images/David.jpg';
import rhysPic from './images/rhys1.jpg';
import andyPic from './images/andy.png';
import AboutBannerSection from './AboutBannerSection/AboutBannerSection';
import Icons from '../../components/Icons/Icons';

const CustomAboutUsPage = () => {
  const intl = useIntl();
  return (
    <Page title={intl.formatMessage({ id: 'CustomAboutUsPage.title' })} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="AboutUsPage" type="floating" overlay={true} />}
        footer={<FooterContainer />}
      >
        <AboutBannerSection intl={intl} />
        <div className={css.contentWidth}>
          <center className={css.mainTitle}>
            <h2
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: 'CustomAboutUsPage.TeamVisionHeading' }),
              }}
            />
          </center>
          <div className={css.aboutUsSec}>
            <div className={css.section}>
              <div className={css.sectionLeft}>
                <Icons name="whoWeAre" />
              </div>
              <div className={css.sectionRight}>
                <h2>Who We Are</h2>
                <p>
                  We are a UK-based construction technology platform connecting modern construction supply with real demand. The Modern Builder brings together self builders, developers, and construction suppliers in one place, helping projects move from idea to delivery with greater clarity, speed and confidence. By combining live planning data, cost insights and a curated supplier marketplace, we give customers the tools to understand their build and the access to engage the right people at the right time. For suppliers, we provide early visibility of opportunities and the ability to connect with high intent customers easily, and at the right time.
                </p>
              </div>
            </div>
            <div className={css.section}>
              <div className={css.sectionLeft}>
                <Icons name="inspiration" />
              </div>
              <div className={css.sectionRight}>
                <h2>The Inspiration</h2>
                <p>
                  Rhys, one of the founders of The Modern Builder, was inspired to start the company after a pivotal call with a self-build client. This client had meticulously prepared building regulations and planning-approved drawings but had already spent over £100,000 on plot reservations and design fees. With a remaining budget of £200,000 to £300,000 for a 250m² luxury house, this was not feasible and Rhys recognised the need for early professional intervention to manage costs and guide clients effectively from the start of their projects.
                </p>
                <p>
                  Realising that many self-build clients could benefit from early-stage advice, Rhys reached out to David and created The Modern Builder to address these needs. The platform aims to simplify the self-build process, providing essential tools and initial services for free. The company earns revenue through construction opportunities passed to builders and advertising, ensuring that clients receive valuable guidance without initial costs.
                </p>
                <p>
                  The Modern Builder helps clients navigate the self-build process, offering solutions to control costs, connect with trusted suppliers, and manage projects efficiently. 
                </p>
              </div>
            </div>
          </div>
          <div className={css.foundingTeamSec}>
            <center className={css.sectionHead}>
              <h2
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({ id: 'CustomAboutUsPage.foundingTeam' }),
                }}
              />
            </center>
            <div className={css.teamSectionWrapper}>
              <div className={css.teamSection}>
                <div className={css.teamImg}>
                  <img src={davidPic} alt="David Johnson" />
                  <div className={css.teamMemberInfo}>
                    <h4>{intl.formatMessage({ id: 'CustomAboutUsPage.davidName' })}</h4>
                    <p>Co-Owner</p>
                  </div>
                </div>
                <div className={css.teamInfo}>
                  <p>{intl.formatMessage({ id: 'CustomAboutUsPage.davidDescription' })}</p>
                  <div className={css.expericeSec}>
                    <div className={css.expericeBlock}>
                      <h3>1,000+</h3>
                      <p>Diverse Projects</p>
                    </div>
                    <div className={css.expericeBlock}>
                      <h3>£1,000+</h3>
                      <p>Million</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={css.teamSection}>
                <div className={css.teamImg}>
                  <img src={rhysPic} alt="Rhys-Evans Edet" />
                  <div className={css.teamMemberInfo}>
                    <h4>{intl.formatMessage({ id: 'CustomAboutUsPage.rhysName' })}</h4>
                    <p>Co-Owner</p>
                  </div>
                </div>
                <div className={css.teamInfo}>
                  <p>{intl.formatMessage({ id: 'CustomAboutUsPage.rhysDescription' })}</p>{' '}
                  <div className={css.expericeSec}>
                    <div className={css.expericeBlock}>
                      <h3>10+</h3>
                      <p>Years</p>
                    </div>
                    <div className={css.expericeBlock}>
                      <h3>£150+</h3>
                      <p>Million</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className={css.teamSection}>
                <div className={css.teamImg}>
                  <img src={andyPic} alt="Rhys-Evans Edet" />
                  <div className={css.teamMemberInfo}>
                    <h4>{intl.formatMessage({ id: 'CustomAboutUsPage.andyName' })}</h4>
                    <p>Development Director</p>
                  </div>
                </div>
                <div className={css.teamInfo}>
                  <p>{intl.formatMessage({ id: 'CustomAboutUsPage.andyDescription' })}</p>{' '}
                  <div className={css.expericeSec}>
                    <div className={css.expericeBlock}>
                      <h3>40</h3>
                      <p>Years experience</p>
                    </div>
                    <div className={css.expericeBlock}>
                      <h3>1000+</h3>
                      <p>Million</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className={css.guideSec}>
            <center className={css.sectionHead}>
              <h2
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({ id: 'CustomAboutUsPage.guideHeading' }),
                }}
              />
            </center>
            <div className={css.guideContent}>
              <div className={css.guideBlock}>
                <Icons name="plotInfomation" />
                <div className={css.guideInfo}>
                  <h2>Plot Identification and Planning</h2>
                  <p>Discover real opportunities using live UK planning data. Identify viable plots and projects early.</p>
                </div>
              </div>
              <div className={css.guideBlock}>
                <Icons name="buildingControl" />
                <div className={css.guideInfo}>
                  <h2>Building Control</h2>
                  <p>Connect with professionals who can support compliance and reduce delays as your project progresses.</p>
                </div>
              </div>
              <div className={css.guideBlock}>
                <Icons name="siteInvestigation" />
                <div className={css.guideInfo}>
                  <h2>Site Investigation and Groundworks</h2>
                  <p>Access the right specialists to assess feasibility, risks and groundwork requirements early.</p>
                </div>
              </div>
              <div className={css.guideBlock}>
                <Icons name="costControl" />
                <div className={css.guideInfo}>
                  <h2>Cost Control</h2>
                  <p>
                    Get a clear understanding of your build costs from the outset. Compare suppliers, refine your specification.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={css.whyChooseUsSec}>
            <center className={css.sectionHead}>
              <h2
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({ id: 'CustomAboutUsPage.whyChooseUsHeading' }),
                }}
              />
            </center>
            <div className={css.guideContent}>
              <div className={css.guideBlock}>
                <strong>Early Access to Opportunities:</strong> Identify projects at the point of planning submission and engage before they reach the wider market.
              </div>
              <div className={css.guideBlock}>
                <strong>Trusted Supplier Network:</strong> Connect with relevant, vetted suppliers suited to your project type, stage and location.
              </div>
              <div className={css.guideBlock}>
                <strong>Data Driven Decisions:</strong>  Use real planning data and cost insights to make smarter, more confident project decisions from day one.
              </div>
              <div className={css.guideBlock}>
                <strong>Built for Simplicity:</strong> Everything in one place. From discovery to delivery, manage your project and connections without unnecessary complexity.
              </div>
            </div>
          </div>
        </div>
        <div className={css.ourValueSec}>
          <div className={css.contentWidth}>
            <div className={css.sectionLine}>
              {['purpose', 'vision', 'mission'].map(key => (
                <div className={css.sectionLineItem} key={key}>
                  <h2>{intl.formatMessage({ id: `CustomAboutUsPage.${key}Title` })}</h2>
                  <p>{intl.formatMessage({ id: `CustomAboutUsPage.${key}Description` })}</p>
                </div>
              ))}
            </div>

            <div className={css.sectionQuote}>
              <center className={css.sectionHead}>
                <h2>{intl.formatMessage({ id: 'CustomAboutUsPage.valueStatement' })}</h2>
              </center>
              <p>{intl.formatMessage({ id: 'CustomAboutUsPage.quote' })}</p>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomAboutUsPage;
